import React, { useState, useEffect } from 'react';
import './App.css';
import { HomePage } from './HomePage';
import { Login } from './Login';
import { SignUp } from './SignUp';
import { Mobile } from './Mobile';
import { Todos } from './Todos';
import { Container } from '@material-ui/core';
import { refreshSession } from 'core/services/auth.service';
import { useSelector, useDispatch } from 'react-redux';
import {
    Router,
    Redirect,
    Switch,
    Route
} from "react-router-dom";
import { LoginSignal } from 'presentation/events';
import { 
    mediateLoginRequester,
    mediateLoginInfoDependent
} from 'mediators';
import { useIdleTimer  } from 'react-idle-timer'
import smoothscroll from 'smoothscroll-polyfill';
import { TasksDialogs } from 'presentation/TasksDialogs';
import { PrivacyPolicy } from 'presentation/PrivacyPolicy';
import { AdminPage } from 'presentation/AdminPage';
import { createBrowserHistory  } from "history";

const history = createBrowserHistory();

// kick off the polyfill!
smoothscroll.polyfill();

const PrivateRoute = ({ children, login, ...rest }) => {
    return (
       <Route
         {...rest}
         render={({ location }) =>
           login ? (
             children
           ) : (
             <Redirect
               to={{
                 pathname: "/",
                 state: { from: location }
               }}
             />
           )
         }
       />
    );
};


const App = () => {
    const login: any | undefined = useSelector(mediateLoginInfoDependent);
    const dispatch = useDispatch()
    const [loginSignal] = useState(new LoginSignal());

    useEffect(() => {
        return history.listen((location) => {
            //@ts-ignore
            if (typeof gtag === 'function') {
                //@ts-ignore
                gtag('set', 'page_path', location.pathname);
                //@ts-ignore
                gtag('event', 'pageview');
            }
        });
    }, []);

    useEffect(() => {
        return mediateLoginRequester(loginSignal, dispatch).destroy;
    }, [loginSignal, dispatch]);

    const handleOnIdle = (evt) => {
        console.log('user is idle', evt)
        console.log('last active', getLastActiveTime())
    };

    const handleOnActive = async (evt) => {
        console.log('user is active', evt)
        console.log('time remaining', getRemainingTime())
        if(login) {
            let updatedLogin = await refreshSession();
            if(updatedLogin) {
                loginSignal.dispatch(updatedLogin);
            }
        }
    };

    const handleOnAction = (evt) => {
        console.log('user did something', evt)
    };

    const { getRemainingTime, getLastActiveTime  } = useIdleTimer({
        timeout: 1000 * 60 * 15,
        onIdle: handleOnIdle,
        onActive: handleOnActive,
        onAction: handleOnAction,
        debounce: 500
    });

  return (
        <Container disableGutters={true} maxWidth={false} className="App">
          <Router history={history}>
            <Switch>
                <Route path='/' exact>
                    <Login />
                </Route>
                <Route path='/signup' exact>
                    <SignUp />
                </Route>
                <Route path='/privacy_policy' exact>
                    <PrivacyPolicy />
                </Route>
                <Route path='/redirect'>
                    <HomePage />
                </Route>
                <Route path='/mobile'>
                    <Mobile />
                </Route>
                <PrivateRoute login={login} path='/home'>
                    <HomePage />
                </PrivateRoute>
                <PrivateRoute login={login} path='/budgets'>
                    <Redirect to='/home' />
                </PrivateRoute>
                <Route path='/todos'>
                    <Redirect to='/projection' />
                </Route>
                <PrivateRoute login={login} path={['/projection', '/inflows', '/bills', '/grouped', '/entries', '/stats', '/suggestions', '/templates']}>
                    <Todos />
                </PrivateRoute>
                <PrivateRoute login={login} path='/admin'>
                    <AdminPage />
                </PrivateRoute>
            </Switch>
          </Router>
           <TasksDialogs />
        </Container>
  );
}

export default App;
